import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { projectTypePatch } from "../../store/projectType/actions";
export var useProjectTypePatch = function (trigger, body, id) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseProjectTypePatch: (_a = state.ProjectType.responseProjectTypePatch) === null || _a === void 0 ? void 0 : _a.data,
            errorProjectTypePatch: state.ProjectType.errorProjectTypePatch,
            loadingProjectTypePatch: state.ProjectType.loadingProjectTypePatch,
        });
    }), responseProjectTypePatch = _a.responseProjectTypePatch, errorProjectTypePatch = _a.errorProjectTypePatch, loadingProjectTypePatch = _a.loadingProjectTypePatch;
    useEffect(function () {
        if (trigger) {
            dispatch(projectTypePatch({
                clientId: body.data.clientId,
                description: body.data.description,
            }, id));
        }
    }, [trigger, body.data.clientId]);
    return {
        responseProjectTypePatch: responseProjectTypePatch,
        errorProjectTypePatch: errorProjectTypePatch,
        loadingProjectTypePatch: loadingProjectTypePatch,
    };
};
